<template>
  <div class="flex flex-col">
    <div class="flex flex-col p-2">
      <span class="text-sm border-b text-gray-400">Route Sync Step</span>
      <div class="w-1/3">
        <CalendarField
          v-model="syncDate"
        />
      </div>
      <div class="flex flex-col gap-2"
        v-if="routeSyncStep">
        <div class="flex flex-row items-center gap-2 py-2">
          <XButton
            class="bg-gray-400 rounded-md h-8 w-8 p-2"
            @click="clearSelectedRouteSyncStep"
          />
          <div class="text-lg font-bold pt-2">{{ routeSyncStep }}</div>
        </div>
        <div class="bg-gray-100 p-2">
          <div class="font-bold">Filter:</div>
          <DataFilter
            :syncStepSelected="routeSyncStep"
            v-model="syncStepConfig"
          />
        </div>
      </div>
      <div class="flex flex-col py-2"
        v-else>
        <div class="text-sm font-italic">
          Choose Sync Step To View
        </div>
        <div class="w-1/3">
          <SyncStepSelector
            v-model="routeSyncStep"
          />
        </div>
      </div>
      <div
        v-if="routeSyncStep">
        <SyncStepDisplay
        />
      </div>
    </div>
  </div>
</template>

<script>
import SyncStepDisplay from './SyncStepDisplay.vue'
import SyncStepSelector from './SyncStepSelector.vue'
import DataFilter from './DataFilter.vue'

import XButton from '../../XButton.vue'

import CalendarField from '../../formComponents/CalendarField.vue'

import user from '../../../services/user/user'
import time from '../../../services/utils/time.js'

export default {
  components: {
    XButton,
    CalendarField,
    SyncStepDisplay,
    SyncStepSelector,
    DataFilter,
  },
  data() {
    return {
      syncDate: undefined,
      syncStepConfig: undefined,

      routeSyncSteps: [],
      routeSyncStep: undefined,
    }
  },
  methods: {
    startRoutePull() {
      console.log('message server to start Route Pull')
    },
    toggleSelectedPartition(index) {
      this.$set(this.selectedPartitions, index, !this.selectedPartitions[index])
    },
    clearSelectedRouteSyncStep() {
      this.routeSyncStep = undefined
      this.syncStepConfig = undefined
    },
  },
  async mounted() {
    this.syncDate = time.today()
    await user.ready()
  },
}
</script>
